import { useCallback } from 'react'
import { useUpdateAndCalculateShipmentMutation } from '../../../store/api/shipments-api'
import Shipment from '../../../types/api/shipment'
import { EndpointQueryParameters } from '../../../types/strapi/strapi'
import { splitLogisticsCost } from '../helpers/split-logistics-cost'
import { useUpdateQueryData } from './use-update-query-data'

/**
 * Делит сумму логистики поровну между отгрузками и сохраняет каждую с пересчётом.
 * Возвращает отгрузки, которые сохранить не удалось.
 */
export function useSetLogisticsCost(queryArg: EndpointQueryParameters) {
    const [updateAndCalculateShipment, state] = useUpdateAndCalculateShipmentMutation()
    const updateQueryData = useUpdateQueryData(queryArg)

    const setLogisticsCost = useCallback(
        async (shipments: Shipment[], total: number): Promise<Shipment[]> => {
            const shares = splitLogisticsCost(total, shipments.length)
            const failed: Shipment[] = []

            for (const [index, shipment] of shipments.entries()) {
                const res = await updateAndCalculateShipment({
                    docId: shipment.documentId,
                    body: { data: { logisticsCost: shares[index] } },
                    queryParams: queryArg,
                })

                if (res.data) {
                    updateQueryData(res.data.data)
                } else {
                    failed.push(shipment)
                }
            }

            return failed
        },
        [updateAndCalculateShipment, queryArg, updateQueryData]
    )

    return { setLogisticsCost, isLoading: state.isLoading }
}
